import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './footer-styles';
import footerCZ from './footerCZ.svg';
import footerEN from './footerEN.svg';
import footerVerticalCZ from './footerVerticalCZ.svg';
import footerVerticalEN from './footerVerticalEN.svg';
import { FormattedMessage } from 'react-intl';
import { LocaleContext } from '@eas/common-web';
import ContainerLayout from '../container-layout/container-layout';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export function Footer() {
  const classes = useStyles();
  const { locale } = useContext(LocaleContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const publicityLogo = isMobile
    ? locale.name === 'en'
      ? footerVerticalEN
      : footerVerticalCZ
    : locale.name === 'en'
    ? footerEN
    : footerCZ;

  return (
    <div className={classes.root}>
      <ContainerLayout className={classes.contactsRoot}>
        <Grid item xs={12} md={3}>
          <Box
            display="flex"
            justifyContent={{ xs: 'center', md: 'flex-start' }}
          >
            <Typography variant="h6" className={classes.linksLabel}>
              <FormattedMessage
                id="KS_P_FOOTER_LINKS"
                defaultMessage="Užitečné odkazy:"
              />
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={9}>
          <Box
            display="flex"
            justifyContent={{ xs: 'space-around', md: 'space-between' }}
            flexWrap="wrap"
            gridColumnGap="1rem"
          >
            <Typography>
              <Link
                className={classes.link}
                href="https://www.crr.gov.cz"
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage
                  id="KS_P_FOOTER_LINKS_CRR"
                  defaultMessage="CRR"
                />
              </Link>
            </Typography>

            <Typography>
              <Link
                className={classes.link}
                href="https://www.mmr.cz"
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage
                  id="KS_P_FOOTER_LINKS_MMR"
                  defaultMessage="MMR"
                />
              </Link>
            </Typography>

            <Typography>
              <Link
                className={classes.link}
                href="https://www.dotaceeu.cz"
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage
                  id="KS_P_FOOTER_LINKS_EU"
                  defaultMessage="DOTACE EU"
                />
              </Link>
            </Typography>

            <Typography className={classes.link}>
              <Link
                className={classes.link}
                href="https://www.irop.mmr.cz"
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage
                  id="KS_P_FOOTER_LINKS_IROP"
                  defaultMessage="IROP"
                />
              </Link>
            </Typography>

            <Typography className={classes.link}>
              <Link
                className={classes.link}
                href="https://mmr.gov.cz/cs/narodni-dotace"
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage
                  id="KS_P_FOOTER_LINKS_NATIONAL_GRANTS"
                  defaultMessage="Národní dotace"
                />
              </Link>
            </Typography>
          </Box>
        </Grid>
      </ContainerLayout>

      <ContainerLayout className={classes.bannerWrapper}>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', md: 'row' }}
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          gridGap={{ xs: '1rem', md: '1.5rem' }}
        >
          <img src={publicityLogo} className={classes.banner} />

          <Typography className={classes.credits}>
            <FormattedMessage
              id="KS_P_FOOTER_CONTACT_COPYRIGHT"
              defaultMessage="Centrum pro regionální rozvoj České republiky © 2021"
            />
          </Typography>
        </Box>
      </ContainerLayout>
    </div>
  );
}
